export default import.meta.ROLLDOWN_FILE_URL_pepImeGiWou_5bV6m4snlg